/**
 * Determine if we are in a test environment.
 * @return boolean
 */
export default function isTestEnvironment() {
    return process.env.NODE_ENV === 'test';
}
